import React, { useState, useEffect } from 'react';
import "../css/PopUpTimer.css";
/**
 * Componente de Pop-up Promocional Horizontal (CSS Puro)
 * - Posición: Fija (derecha inferior)
 * - Retraso inicial: 2 segundos
 * - Duración: 20 segundos con auto-cierre
 * - Estilos: CSS Estándar (sin Tailwind)
 */
const App = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  
  const DISPLAY_DURATION = 20000; // 20 segundos
  const INITIAL_DELAY = 2000;    // 2 segundos antes de aparecer

  useEffect(() => {
    // 1. Mostrar el popup tras el retraso inicial
    const showTimer = setTimeout(() => {
      setIsVisible(true);
      // Activar la barra de progreso justo después de mostrarse
      setTimeout(() => setIsAnimating(true), 50);
    }, INITIAL_DELAY);

    // 2. Cerrar automáticamente tras la duración total
    const autoCloseTimer = setTimeout(() => {
      handleClose();
    }, INITIAL_DELAY + DISPLAY_DURATION);

    return () => {
      clearTimeout(showTimer);
      clearTimeout(autoCloseTimer);
    };
  }, []);

  const handleClose = (e) => {
    if (e) e.preventDefault();
    setIsVisible(false);
  };

  return (
    <div className="main-page-container">

 

      {/* Estructura del Pop-up */}
      <div className={`popup-wrapper ${isVisible ? 'is-visible' : ''}`}>
        <div className="popup-card">
          
          <button 
            className="close-button" 
            onClick={(e) => handleClose(e)}
            title="Cerrar"
          >
            &times;
          </button>

          <a 
            href="https://utpl.edu.ec/doctorado-quimica" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="full-link"
          >
            <div className="image-box">
              <img 
                src="https://www.utpl.edu.ec/carreras/sites/default/files/Dise%C3%B1o%20sin%20t%C3%ADtulo_7.png" 
                alt="Producto" 
              />
            </div>

            <div className="text-box">
              <span className="tag">Exclusivo</span>
              <h3>Doctorado en Química</h3>
              <p>Inicio de clases: Octubre 2026</p>
              <a className='link-with-arrow'>Postula ahora</a>
            </div>

            {/* Barra de progreso */}
            <div className="progress-container">
              <div 
                className="progress-fill"
                style={{ 
                  width: isAnimating ? '0%' : '100%',
                  transitionDuration: isAnimating ? `${DISPLAY_DURATION}ms` : '0ms'
                }}
              />
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default App;